<div class="row" style="padding: 15px 5px 15px 15px; font-size: small;" [formGroup]="group">
  <div class="row col-md-12" style="padding-bottom: 12px;" *ngIf="group?.get('filters')?.get('filter')?.value?.length">
    <div class="kt-portlet__body filter-width">
      <div class="kt-form" formGroupName="filters">
        <div formArrayName="filter">
          <div class="filterSection"
            *ngFor="let filterGroup of group?.get('filters')?.get('filter')['controls']; let i = index">
            <div style="width: 64px;" class="operatorWidth filter-text-styles" *ngIf="i === 0">
              Filter
            </div>
            <div class="operatorWidth boolean-class" *ngIf="i === 1 && group?.get('filters')?.get('filter')?.value?.length"
              [ngStyle]="{'width':  group.get('filters').get('operator').value == 'OR'? '50px' : '60px' }">
              <kt-select [options]="operatorOptions" [formControl]="group.get('filters').get('operator')"></kt-select>
            </div>
            <div *ngIf="i > 1" class="operatorWidth boolean-class operator-read-only"
              [ngStyle]="{'width':  group?.get('filters').get('operator').value == 'OR'? '50px' : '60px' }">
              <kt-select [options]="operatorOptions" [disabled]="true"
                [ngModel]="group?.get('filters').get('operator').value" [ngModelOptions]="{ standalone: true }"></kt-select>
            </div>

            <div [formGroupName]="i" class="subFilterSection">
              <div formArrayName="subFilter">
                <div class="mb-3" *ngFor="let subFilter of filterGroup.get('subFilter')['controls']; let j = index">
                  <div [formGroupName]="j" class="subfilter-items">
                    <div style="font-weight: 500;font-size: 12px;" class="subOperatorWidth" *ngIf="j === 0; else subOperatorDisplay">Where</div>
                    <ng-template #subOperatorDisplay>
                      <div *ngIf="j === 1" class="subOperatorWidth">
                        <kt-select [options]="operatorOptions" [formControl]="filterGroup.get('subOperator')"></kt-select>
                      </div>
                      <div *ngIf="j > 1" class="subOperatorWidth">{{ filterGroup.get('subOperator').value }}</div>
                    </ng-template>
                    <kt-select class="col-md-4" [label]="'Column'" [placeholder]="'Select Column'" formControlName="column"
                      [disabled]="subFilter.get('disabled').value || group?.get('calc').value"
                      [options]="columnOptions"
                      (selectionChange)="onColumnSelect($event, group.get('targetCollection').value, group, i, j)">
                    </kt-select>
                    <kt-select class="col-md-2" [label]="'Check'" [placeholder]="'Select Check'" formControlName="check"
                      [disabled]="subFilter.get('disabled').value"
                      [options]="getCheckOptions(subFilter)"
                      (selectionChange)="onCheckOptionClick($event, group, i, j)">
                    </kt-select>
                    <ng-container [ngSwitch]="isInputType(group.get('targetCollection').value, group, i, j)">
                      <kt-input *ngSwitchCase="'input'" class="col-md-4" [label]="'Value'" placeholder="Enter value"
                        formControlName="values" [disabled]="subFilter.get('disabled').value"></kt-input>
                      <ng-container *ngSwitchCase="'list'">
                        <kt-select *ngIf="isMultipleSelect(group, i, j)" class="col-md-4" [label]="'Value'"
                          [placeholder]="isSubFilterLoading(subFilter) ? 'Loading...' : 'Select value'"
                          formControlName="values" [multiple]="true" [searchable]="true"
                          [disabled]="subFilter.get('disabled').value"
                          [loading]="isSubFilterLoading(subFilter)"
                          [options]="getValueOptions(subFilter)"
                          searchPlaceholder="Search..." noResultsText="No matching item found"></kt-select>

                        <kt-select *ngIf="!isMultipleSelect(group, i, j)" class="col-md-4" [label]="'Value'"
                          [placeholder]="isSubFilterLoading(subFilter) ? 'Loading...' : 'Select value'"
                          formControlName="values" [multiple]="false" [searchable]="true"
                          [disabled]="subFilter.get('disabled').value"
                          [loading]="isSubFilterLoading(subFilter)"
                          [options]="getValueOptions(subFilter)"
                          searchPlaceholder="Search..." noResultsText="No matching item found"></kt-select>
                      </ng-container>
                      <kt-date-picker *ngSwitchCase="'date'" class="col-md-4" [label]="'Value'" placeholder="Choose a date"
                        formControlName="values" [disabled]="subFilter.get('disabled').value"></kt-date-picker>

                      <ng-container *ngSwitchCase="'dateRange'">
                        <div style="display: flex; align-self: end;" class="col-md-4 date-range-block">
                          <kt-button-v1 variant="stroked" [matMenuTriggerFor]="menu" #t="matMenuTrigger"
                            icon="calendar_today" iconPosition="suffix"
                            [label]="subFilter.get('range.custom').value?.name || 'Select Date Range'"></kt-button-v1>
                          <mat-menu class="date-range-mat-menu" #menu="matMenu" [hasBackdrop]="true" overlapTrigger>
                            <div class="row" style="max-width: 100%; margin: auto; padding: 10px" formGroupName="range">
                              {{range | json}}
                              <div class="col-sm-6 custom-range">
                                <div (click)="$event.stopPropagation();">
                                  <mat-form-field class="mat-form-field-fluid">
                                    <mat-label>Enter a date range</mat-label>
                                    <mat-date-range-input (click)="picker.open()" width [rangePicker]="picker">
                                      <input matStartDate formControlName="from" placeholder="Start date">
                                      <input matEndDate formControlName="to" placeholder="End date">
                                    </mat-date-range-input>
                                    <mat-date-range-picker #picker></mat-date-range-picker>
                                  </mat-form-field>
                                </div>
                                <div>
                                  <kt-button-v1 variant="flat" color="primary" [disabled]="!isDateRangeValid(subFilter)"
                                    [label]="'Apply Time change'" (btnClick)="pickTimeRange({id:99,name:''}, subFilter)"></kt-button-v1>
                                </div>
                              </div>
                              <div class="col-sm-6 fixed-range">
                                <ng-container *ngFor="let time of timeRanges">
                                  <button
                                    [ngStyle]="{'color' : subFilter.get('range.custom').value?.id == time?.id ? 'blue' : 'rgba(0,0,0,.54)' }"
                                    mat-menu-item (click)="pickTimeRange(time, subFilter)">{{time?.name}}</button>
                                </ng-container>

                              </div>
                            </div>
                          </mat-menu>
                        </div>
                      </ng-container>

                      <ng-container *ngSwitchCase="'between'">
                        <div *ngIf="group?.get('calc').value" style="display: flex;" formGroupName="range" class="col-md-4">
                          <kt-input class="col-md-5" [label]="'From'" placeholder="Enter value" formControlName="from"></kt-input>
                          <div class="col-md-2" style="margin-top: 18px; margin-left: -6px;">And</div>
                          <kt-input class="col-md-5" [label]="'To'" placeholder="Enter value" formControlName="to"></kt-input>
                        </div>
                      </ng-container>
                      <ng-container *ngSwitchDefault>
                        <kt-input class="col-md-4" [label]="'Value'" placeholder="Enter value"
                          formControlName="values" [disabled]="subFilter.get('disabled').value"></kt-input>
                      </ng-container>
                    </ng-container>

                    <kt-button-v1 bordered="true" style="align-self: end;" variant="icon" icon="delete"
                      [disabled]="subFilter.get('disabled').value" (btnClick)="removeSubFilter(i, j)"
                      [tooltip]="getSubfilterDeleteTooltip(subFilter.get('disabled').value, subFilter.get('column').value)"></kt-button-v1>
                  </div>
                </div>
                <div class="filter-section-buttons">
                  <kt-button-v1 variant="stroked" icon="add" [label]="'Add Sub filter'" tooltip="Add Sub-Filter"
                    [disabled]="group?.get('calc').value" (btnClick)="addSubFilter(i)"></kt-button-v1>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="buttons-container">
    <div class="add-button">
      <kt-button-v1 variant="stroked" icon="add" [label]="'Add Filter'" tooltip="Add Filter"
        [disabled]="group?.get('filters')?.get('filter')?.length > 0 && group?.get('calc').value"
        (btnClick)="addFilter()"></kt-button-v1>
    </div>

    <div class="d-flex">
      <div class="add-button">
        <kt-button-v1 variant="stroked" [label]="'Clear All'" tooltip="Clear All" (btnClick)="clearFilter()"></kt-button-v1>
      </div>
      <div class="add-button">
        <kt-button-v1 variant="flat" color="primary" [label]="'Apply'" tooltip="Apply" (btnClick)="applyFilter()"></kt-button-v1>
      </div>
    </div>
  </div>
</div>
